
export default {
  props: {
    block: {
      type: Object,
      default: () => null,
    },
  },
  data () {
    return {
      news: [],
      categoryNews: [],
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.getNews();
      this.getCategoryNews();
    });
  },
  methods: {
    async getNews () {
      const queryParams = {
        fields: `id,title,date,excerpt,acf,image,slug,type,categories`,
        posts: {
          post_type: `post`,
          posts_per_page: 4,
          post__in: this.block.news_items.map(item => item.news_post.ID),
          orderby: `post__in`,
        },
        options: {
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.news = request;
      }
    },
    async getCategoryNews () {
      const queryParams = {
        fields: `id,title,date,excerpt,acf,image,slug,type,categories`,
        posts: {
          post_type: `post`,
          posts_per_page: 4,
          category: this.block.news.news_category.term_id,
          orderby: `date`,
          order: `DESC`,
        },
        options: {
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.categoryNews = request;
      }
    },
  },
};
